export default __webpack_public_path__ + "static/media/webinars.3b8a0e74.png";